import { render, staticRenderFns } from "./rootMatcher.vue?vue&type=template&id=310f3373"
import script from "./rootMatcher.vue?vue&type=script&lang=js"
export * from "./rootMatcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports